


export const FIRSTUPSELLOPTIONS = {
    offerText: {
        optionName: 'Offer Text',
        optionValue: 'offerText',
        customizeProperties: {
            text: {
              propertyName: "Text",
              propertyType: "text",
              propertyMaxLength: "150",
              propertyValue:
                "Get an Exclusive 10% OFF for You!",
            },
          textColor: {
            propertyName: "Text-Color",
            propertyType: "color",
            propertyValue: "#000000",
          },
          fontStyle: {
              propertyName: "Font-Style",
              propertyType: "select",
              propertyValue: "normal",
              propertyOptions: [
                {
                  optionName: "Normal",
                  optionValue: "normal",
                },
                {
                  optionName: "Italic",
                  optionValue: "italic",
                },
              ],
          },
          fontFamily: {
            propertyName: 'Font-Family',
            propertyType: 'select',
            propertyValue: 'sans-serif',
            propertyOptions: [
              {
                optionName: "Serif",
                optionValue: "serif",
              },
              {
                optionName: "Cursive",
                optionValue: "cursive",
              },
              {
                optionName: "Sans-Serif",
                optionValue: "sans-serif",
              },
            ],
          },
        },
      },

      products: {
        optionName: 'All Products',
        optionValue: 'products',
        customizeProperties: {
          borderColor: {
            propertyName: "Border-Color",
            propertyType: "color",
            propertyValue: "#ffffff",
          },
          borderStyle: {
            propertyName: "Border-Style",
            propertyType: "select",
            propertyValue: "solid",
            propertyOptions: [
              {
                optionName: "None",
                optionValue: "none",
              },
              {
                optionName: "Dotted",
                optionValue: "dotted",
              },
              {
                optionName: "Dashed",
                optionValue: "dashed",
              },
              {
                optionName: "Solid",
                optionValue: "solid",
              },
            ],
          },
          borderWidth: {
            propertyName: "Border-Width",
            propertyType: "number",
            propertyValue: 0,
          },
          textColor: {
            propertyName: "Text-Color",
            propertyType: "color",
            propertyValue: "#000000",
          },
          fontStyle: {
              propertyName: "Font-Style",
              propertyType: "select",
              propertyValue: "normal",
              propertyOptions: [
                {
                  optionName: "Normal",
                  optionValue: "normal",
                },
                {
                  optionName: "Italic",
                  optionValue: "italic",
                },
              ],
          },
          fontFamily: {
            propertyName: 'Font-Family',
            propertyType: 'select',
            propertyValue: 'sans-serif',
            propertyOptions: [
              {
                optionName: "Serif",
                optionValue: "serif",
              },
              {
                optionName: "Cursive",
                optionValue: "cursive",
              },
              {
                optionName: "Sans-Serif",
                optionValue: "sans-serif",
              },
            ],
          },
        },
      },

      product1: {
        optionName: 'Product 1',
        optionValue: 'product1',
        customizeProperties: {
          text: {
            propertyName: "Text",
            propertyType: "text",
            propertyMaxLength: "30",
            propertyValue:
              "Product 1 Name",
          },
          link: {
            propertyName: "Product-Link",
            propertyType: "text",
            propertyValue: ''
          },
          image: {
            propertyName: 'Image',
            propertyType: 'text',
            propertyValue: '',
          },
        }
      },
      product2: {
        optionName: 'Product 2',
        optionValue: 'product2',
        customizeProperties: {
          text: {
            propertyName: "Text",
            propertyType: "text",
            propertyMaxLength: "30",
            propertyValue:
              "Product 2 Name",
          },
          link: {
            propertyName: "Product-Link",
            propertyType: "text",
            propertyValue: ''
          },
          image: {
            propertyName: 'Image',
            propertyType: 'text',
            propertyValue: '',
          },
          disable: false,
        }
      },
      product3: {
        optionName: 'Product 3',
        optionValue: 'product3',
        customizeProperties: {
          text: {
            propertyName: "Text",
            propertyType: "text",
            propertyMaxLength: "30",
            propertyValue:
              "Product 3 Name",
          },
          link: {
            propertyName: "Product-Link",
            propertyType: "text",
            propertyValue: ''
          },
          image: {
            propertyName: 'Image',
            propertyType: 'text',
            propertyValue: '',
          },
          disable: false
        }
      },


      nudge: {
        optionName: "Nudge",
        optionValue: "nudge",
        customizeProperties: {
          backgroundColor: {
            propertyName: "Background-Color",
            propertyType: "color",
            propertyValue: "#ffffff",
          },
          borderColor: {
            propertyName: "Border-Color",
            propertyType: "color",
            propertyValue: "#ffffff",
          },
          borderStyle: {
            propertyName: "Border-Style",
            propertyType: "select",
            propertyValue: "solid",
            propertyOptions: [
              {
                optionName: "None",
                optionValue: "none",
              },
              {
                optionName: "Dotted",
                optionValue: "dotted",
              },
              {
                optionName: "Dashed",
                optionValue: "dashed",
              },
              {
                optionName: "Solid",
                optionValue: "solid",
              },
            ],
          },
          borderWidth: {
            propertyName: "Border-Width",
            propertyType: "number",
            propertyValue: 0,
          },
        },
        nudgePosition: {
          optionName: "Nudge Position",
          optionValue: "nudgePosition",
          customizeProperties: {
            left: 0
          }
        }

      }
} 